<template>
    <div style="background-color: white;color: black;">
        <mt-header title="咨詢費通知"></mt-header>
        <div style="padding: 20px;">
            <span style="font-size: 20px;"><span style="color: red;">{{dateCode}}</span>期的咨詢費已經發放, 請登入系統查看咨詢費詳細!</span>
        </div>


    </div>
</template>

<script>
    import "mint-ui/lib/style.css";
    import { Header } from 'mint-ui';
    import {wechatCalendar} from '../../api/api'

    export default {
        data() {
            //驗證登錄名字
            return {
                dateCode:""
            }
        },
        methods: {

        },
        mounted() {
           this.dateCode = this.$route.query.dateCode;
        },
        computed: {

        },
        activated(){

        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/views/wechat/CommNote.vue